document.addEventListener("DOMContentLoaded", function () {
  // ==============================================
  // CONFIG
  // ==============================================
  var MATERIAL_NAME = "Material";
  var SIZE_NAME = "Size";
  var FINISH_NAME = "Finish";

  // ==============================================
  // HELPERS
  // ==============================================
  function getCheckedValue(name) {
    var el = document.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : null;
  }

  function getFinishWrapper(input) {
    // Many themes wrap radio inputs with <label for="...">
    var label = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
    return label || input.closest("label") || input.closest(".swatch-element") || input.parentElement;
  }

  function parseVariantFromUrl() {
    try {
      return new URL(window.location.href).searchParams.get("variant");
    } catch (e) {
      return null;
    }
  }

  function readVariantIdFromDom() {
    // Fallback for themes/apps that store selected variant in a hidden input
    var el = document.querySelector('input[name="id"], select[name="id"]');
    if (!el) return null;
    return el.value ? String(el.value) : null;
  }

  function getCurrentVariantId() {
    // 1) Prefer URL if present (Oil sets it after interaction)
    var v = parseVariantFromUrl();
    if (v) return String(v);

    // 2) Fallback to DOM hidden input if available
    v = readVariantIdFromDom();
    if (v) return String(v);

    return null;
  }

  // ==============================================
  // 1) FILTER FINISH OPTIONS BY MATERIAL
  // ==============================================
  var materialRadios = document.querySelectorAll('input[name="' + MATERIAL_NAME + '"]');
  var finishRadios = document.querySelectorAll('input[name="' + FINISH_NAME + '"]');

  var finishItems = [];

  finishRadios.forEach(function (radio) {
    var wrapper = getFinishWrapper(radio);
    if (!wrapper) return;

    var value = (radio.value || "").toLowerCase();
    var materialType = null;

    // Paper finishes
    if (value.includes("white border") || value.includes("deckled")) {
      materialType = "paper";
    }

    // Canvas finishes
    if (value.includes("rolled") || value.includes("stretched")) {
      materialType = "canvas";
    }

    finishItems.push({
      radio: radio,
      wrapper: wrapper,
      materialType: materialType
    });
  });

  function applyFinishFilter() {
    var selectedMaterial = (getCheckedValue(MATERIAL_NAME) || "").toLowerCase();
    if (!selectedMaterial) return;

    var firstVisible = null;

    finishItems.forEach(function (item) {
      if (!item.materialType || !item.wrapper) return;

      if (item.materialType === selectedMaterial) {
        item.wrapper.style.display = "";
        item.radio.disabled = false;
        if (!firstVisible && !item.radio.disabled) firstVisible = item.radio;
      } else {
        item.wrapper.style.display = "none";
        item.radio.disabled = true;

        // Uncheck if hidden
        if (item.radio.checked) item.radio.checked = false;
      }
    });

    // Auto-select the first visible finish if none is selected
    var checkedFinish = document.querySelector('input[name="' + FINISH_NAME + '"]:checked');
    if (!checkedFinish && firstVisible) {
      firstVisible.checked = true;
      firstVisible.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  // ==============================================
  // 2) DYNAMIC VARIANT DESCRIPTION (FROM JSON)
  // ==============================================
  var descScript = document.querySelector('script[id^="variant-descriptions-"]');
  var variantDescriptions = null;

  if (descScript) {
    try {
      variantDescriptions = JSON.parse(descScript.textContent.trim());
    } catch (e) {
      variantDescriptions = null;
    }
  }

  var lastVariantId = null;
  var lastHtml = null;

  function updateVariantDescription() {
    var box = document.querySelector(".variant-dynamic-description");
    if (!box) return;
    if (!variantDescriptions) return;

    var variantId = getCurrentVariantId();
    if (!variantId) return;

    // Avoid unnecessary DOM writes
    if (variantId === lastVariantId && box.innerHTML === lastHtml) return;

    var html = variantDescriptions[String(variantId)];

    if (html) {
      if (box.innerHTML !== html) box.innerHTML = html;
      box.style.display = "block";
      lastHtml = html;
    } else {
      if (box.innerHTML !== "") box.innerHTML = "";
      box.style.display = "none";
      lastHtml = "";
    }

    lastVariantId = variantId;
  }

  // ==============================================
  // LISTENERS
  // ==============================================
  // Update filtering + description when Material changes
  materialRadios.forEach(function (radio) {
    radio.addEventListener("change", function () {
      applyFinishFilter();
      updateVariantDescription();
    });
  });

  // Update description when Size/Finish changes
  var optionInputs = document.querySelectorAll(
    'input[name="' + MATERIAL_NAME + '"], input[name="' + SIZE_NAME + '"], input[name="' + FINISH_NAME + '"]'
  );

  optionInputs.forEach(function (input) {
    input.addEventListener("change", function () {
      applyFinishFilter();
      updateVariantDescription();
    });
  });

  // ==============================================
  // INIT + POLLING (Oil sets ?variant after interaction)
  // ==============================================
  applyFinishFilter();
  updateVariantDescription();

  // Polling is the most reliable approach across themes/apps
    setInterval(function () {
    applyFinishFilter();
    updateVariantDescription();
    updateLeadTimeText();
    }, 300);

// ==============================================
// 3) LEAD TIME (DYNAMIC) UNDER ADD TO CART
// ==============================================

function updateLeadTimeText() {
  var el = document.querySelector('[data-product-quick-notes] [data-lead-time]');
  if (!el) return;

  var material = (getCheckedValue(MATERIAL_NAME) || "").toLowerCase();
  var finish = (getCheckedValue(FINISH_NAME) || "").toLowerCase();

  // Rules:
  // - Paper (any Paper finish) => 2-3 weeks
  // - Canvas + Rolled => 2-3 weeks
  // - Canvas + Stretched => 4-6 weeks
  var text = "Allow 2-3 weeks";

  if (material === "canvas" && finish.includes("stretched")) {
    text = "Allow 4-6 weeks";
  }

  el.textContent = text;
}

});
